import { Injectable } from '@angular/core';
import { FirestoreSubCollectionRepository } from '@core/services';
import { ClientIntakeResponse } from './state/clientIntakeResponses.firebase.models';

export interface ClientIntakeResponsesPathParams {
	businessId: string;
	matterId: string;
	clientIntakeFormId: string;
}

export interface CurrentClientIntakeResponsePathParams
	extends ClientIntakeResponsesPathParams {
	clientIntakeResponseId: string;
}

@Injectable({
	providedIn: 'root',
})
export class ClientIntakeResponsesSubCollectionRepo extends FirestoreSubCollectionRepository<
	ClientIntakeResponse,
	ClientIntakeResponsesPathParams
> {
	protected getCollectionPath(params: ClientIntakeResponsesPathParams): string {
		return `businesses/${params.businessId}/matters/${params.matterId}/clientIntakeForms/${params.clientIntakeFormId}/clientIntakeResponses`;
	}
}
